export default "__VITE_ASSET__DTTlTxvL__"